import { useLocation } from "react-router-dom";

export const useQueryRoute = (param) => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
  
    return query.get(param);
}